import dayjs from 'utils/dayjs';

export function getCalendarColumnDefinitions(
    range,
    todayColId,
    displayDateFormat,
    columnExtras,
) {
    const alignTextRight = { cellStyle: { textAlign: 'right' } };
    return range.map((dayDate) => {
        const isWeekEnd = [0, 6].includes(dayDate.day());
        const style = {
            headerClass: 'BRCellCalendar',
            cellClass: 'BRCellCalendar',
        };
        if (isWeekEnd) {
            style.headerClass += ' BRCellWeekend';
            style.cellClass += ' BRCellWeekend';
        }

        const isToday = dayDate.isSame(dayjs(), 'day');
        if (isToday) {
            style.headerClass += ' BRCellHighlight';
            style.cellClass += ' BRCellHighlight';
        }


        return {
            field: dayDate.format(displayDateFormat),
            title: dayDate.format(displayDateFormat),
            align: 'center',
            colId: isToday ? todayColId : null,
            width: 100,
            ...style,
            ...alignTextRight,
            ...columnExtras,
            headerComponentParams: {
                ...columnExtras.headerComponentParams,
            },
        };
    });
}
